import React from 'react';
import styled from 'styled-components';
import { OfferWallBrands } from '../types';

const Container = styled.div`
  padding: 35px 24px 24px 24px;
`;

const BrandItem = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  height: 72px;
  border-bottom: 1px solid #e7e7e7;
`;

const Text = styled.p`
  padding-inline: 30px;
  margin: 0;
  font-size: 14px;
`;

const Logo = styled.img`
  width: 65px;
`;

interface Props {
  brands?: OfferWallBrands[];
}

const Brands: React.FC<Props> = ({ brands }) => {
  return (
    <Container>
      {brands?.map((item, index) => {
        const key = `brand-${index}`;
        const id = item?.id;
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const image = require(`../../Assets/OfferWall/${id}.png`).default;
        return (
          <BrandItem key={key}>
            <Logo alt={item.name} src={image} />
            <Text>{item?.name}</Text>
          </BrandItem>
        );
      })}
    </Container>
  );
};

export default Brands;
